/**
 * @file Renders the slider's previous and next arrow button.
 */
import type { MouseEventHandler } from "react";
import { Button } from "antd";

type Props = {
  onClick?: MouseEventHandler<HTMLElement>;
  className?: string;
};

/**
 * Renders a slider navigation arrow button.
 */
const Arrow = ({
  onClick = undefined,
  className = undefined,
}: Props): JSX.Element => {
  return (
    <Button onClick={onClick} className={className} />
  );
};

export default Arrow;
